// 单单抽新旧皮肤配置控制
export const skinConfig = false; // true: 新皮肤，false: 旧皮肤